import { getBackendBaseUrl } from './apiUtils';
import 'whatwg-fetch';

export interface SessionRequestInfo {
  token: string;
  displayName: string;
  inCallChat?: boolean;
}

export const joinSession = async ({ token, displayName, inCallChat }: SessionRequestInfo) => {
  const telehealthBaseURL = getBackendBaseUrl();
  const data = await fetch(
    `${telehealthBaseURL}/join-session?token=${token}&displayName=${displayName}&inCallChat=${inCallChat}`,
    {
      method: 'POST',
    }
  );

  if (data.status !== 200) {
    throw new Error('Failed API join-session');
  }

  const { jwt, telehealthVisitUserId, thVendor } = (await data.json()) as JoinSessionSuccessResponse;
  return { jwt, telehealthVisitUserId, thVendor };
};
